
<div class="form__group--border py-16 pb-32">
  <legend class="form__label pb-4">Maximum pets you'll watch at one time</legend>
  <poppins-dropdown
    id="number-of-pets"
    ref="maxPets"
    v-model="maxNumberOfPets"
    labelName="# of pets"
    :options="options"
    :status="formStatuses.maxNumberOfPets"
    :helperText="helperText(formStatuses.maxNumberOfPets)"
    @blur="validate"
  />
</div>
